import {
  Box,
  Button,
  Container,
  Grid,
  Link, makeStyles, TextField,
  Typography
} from '@material-ui/core';
import { Formik } from 'formik';
import React, { useEffect } from 'react';
import { GoogleLogin } from 'react-google-login';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import Page from 'src/components/Page';
import { alertService } from 'src/components/toaster/alert.service';
import { history } from 'src/utils/utils';
import * as Yup from 'yup';
import LoginService from '../../services/sigin-signup/login.service';
import LocalStorageService from '../../services/storage/local-storage.service';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const loginService = new LoginService();
const localStorageService = LocalStorageService.getService();
const LoginView = () => {
  const classes = useStyles();
  //const navigate = useNavigate();
  // if(localStorage.token){
  //   history.push('/app/dashboard');
  // }

  const redirectRoute = () => {

    const lastPathname = localStorage.getItem('lastPathname');
    const searchParams = localStorage.getItem('searchParams');
    if (lastPathname && lastPathname !== '') {
      history.push(`${lastPathname}${searchParams && searchParams !== '' ? searchParams : ''}`);
    } else {
      history.push('/app/dashboard');
    }
  }
  const responseGoogle = (response) => {
    if (response && response.profileObj) {
      console.log(response);
      const values = {
        userName: response.profileObj.name,
        email: response.profileObj.email,
        password: response.profileObj.googleId,
        isGoogleLogin: true,
        token: response.accessToken
      };
      loginService.userSignup(values).then((res) => {
        if (res) {
          localStorage.setItem('user', res.userName)
          localStorageService.setToken(res);
          history.push('/app/dashboard');
          // navigate('/app/dashboard', { replace: true });
        } else {
          loginService.userLogin(values).then((res) => {
            if (res) {
              localStorage.setItem('user', res.userName);
              localStorageService.setToken(res);
              redirectRoute();
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem('lastPathname');
      localStorage.removeItem('searchParams');
    }
  }, []);
  return (
    <Page
      className={classes.root}
      title="Login"
    >

      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="xs">
          <Formik
            initialValues={{
              email: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string().email('Must be a valid email').max(255).required('Email is required'),
              password: Yup.string().max(255).required('Password is required')
            })}
            onSubmit={(values) => {
              loginService.userLogin(values).then((res) => {
                if (
                  res &&
                  !isNaN(res.isAdminVerified) &&
                  res.isAdminVerified &&
                  !isNaN(res.isVerified) &&
                  res.isVerified
                ) {
                  localStorage.setItem('user', res.userName);
                  localStorageService.setToken(res);
                  redirectRoute();
                  // navigate('/app/dashboard', { replace: true });
                }
                if (
                  res &&
                  isNaN(res.isAdminVerified) &&
                  !res.isAdminVerified &&
                  isNaN(res.isVerified) &&
                  !res.isVerified
                ) {
                  alertService.success(
                    res.message ?? "Please verify your email."
                  )
                }
              }).error((err) => {
                console.log(':: err ', err);
              });

              // navigate('/app/dashboard', { replace: true });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                    align="center"

                  >
                    Sign In to Your Account
                  </Typography>
                  {/* <Typography
                      gutterBottom
                      align="right"
                      variant="body2"
                    >
                      (Sign in on the internal platform)
                  </Typography> */}
                </Box>
                <Grid
                  container
                  spacing={3}
                  style={{ "marginBottom": "10px" }}
                >

                </Grid>

                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box my={2}>
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign in now
                  </Button>
                </Box>
                <Typography
                  align="center"
                  variant="body1"
                >
                  Don&apos;t have an account?
                  {' '}
                  <Link
                    component={RouterLink}
                    to="/auth/register"
                    variant="h6"
                  >
                    Sign up
                  </Link>
                </Typography>
                <Box
                  mt={3}
                  mb={1}
                >
                  <Typography align="center" variant="body1" id="orRow" >
                    <div class="lineSeparators"></div>
                    <div class="orTxt"> or </div>
                    <div class="lineSeparators"></div>
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                    md={12}
                    align="center"
                    id="gbtnL"
                    style={{ "marginTop": "2px", "text-align": "center" }}
                  >
                    <GoogleLogin
                      clientId="924694172086-b4m0v07fj8hmdtj6d6s1c9gacl06cffh.apps.googleusercontent.com"
                      buttonText="Login with Google"
                      onSuccess={responseGoogle}
                      onFailure={responseGoogle}
                      cookiePolicy={'single_host_origin'}

                    />
                    {/* <Button
                        fullWidth
                        startIcon={<GoogleIcon />}
                        onClick={handleSubmit}
                        size="large"
                        variant="contained"
                      >
                        Login with Google
                    </Button> */}
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default withRouter(LoginView);
